export const githubAPI = "https://api.github.com";
